<template>
  <div>
    <div class="d-flex flex-wrap">
      <div class="col-md-12">
        <h4 class="mt-4 mb-3 title-custom">
          Cambios solicitados: Número de serie
        </h4>
      </div>
    </div>

    <div class="d-flex flex-wrap">
      <div class="col-md-12">
        <ul class="nav nav-tabs justify-content-end" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link active"
              id="home-tab"
              data-bs-toggle="tab"
              data-bs-target="#home-tab-pane"
              type="button"
              role="tab"
              aria-controls="home-tab-pane"
              aria-selected="true"
            >
              Vehículo
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="contact-tab"
              data-bs-toggle="tab"
              data-bs-target="#contact-tab-pane"
              type="button"
              role="tab"
              aria-controls="contact-tab-pane"
              aria-selected="false"
            >
              Mensajes
            </button>
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="home-tab-pane"
            role="tabpanel"
            aria-labelledby="home-tab"
            tabindex="0"
          >
            <h4 class="title-custom mt-4">Datos originales</h4>

            <div class="row mt-4">
              <div class="col-md-3">
                <p>
                  Kilometraje:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].KILOMETRAJE
                  }}</span>
                </p>
              </div>
              <div class="col-md-9">
                <p>
                  Descripción:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].VEHICULO
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Marca:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].MARCA
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Modelo:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].MODELO
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Submarca:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].SUBMARCA
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Numero de Serie:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].SERIE
                  }}</span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  Numero de identificación vehicular (NIV):
                  <span class="label-custom-bold"></span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  Número de motor:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].MOTOR
                  }}</span>
                </p>
              </div>
              <div class="col-md-12">
                <p>
                  Placas:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].PLACA
                  }}</span>
                </p>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-12">
                <hr />
              </div>
            </div>

            <h4 class="title-custom mt-4">Datos a modificar</h4>

            <div class="row mt-4">
              <div class="col-md-3">
                <p>
                  Kilometraje:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].KILOMETRAJE
                  }}</span>
                </p>
              </div>
              <div class="col-md-9">
                <p>
                  Descripción:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].VEHICULO
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Marca:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].MARCA
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Modelo:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].MODELO
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Submarca:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].SUBMARCA
                  }}</span>
                </p>
              </div>
              <div class="col-md-3">
                <p>
                  Numero de Serie:
                  <input type="text" class="form-control" v-model="numSerie" />
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  Numero de identificación vehicular (NIV):
                  <span class="label-custom-bold"></span>
                </p>
              </div>
              <div class="col-md-6">
                <p>
                  Número de motor:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].MOTOR
                  }}</span>
                </p>
              </div>
              <div class="col-md-12">
                <p>
                  Placas:
                  <span class="label-custom-bold">{{
                    datosPoliza.INCISO[0].PLACA
                  }}</span>
                </p>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-12 mt-4 d-flex justify-content-end">
                <button
                  class="btn btn-primary btn-rounded"
                  @click="guardarCambios"
                >
                  Enviar
                </button>
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="contact-tab-pane"
            role="tabpanel"
            aria-labelledby="contact-tab"
            tabindex="0"
          >
            <div class="row mt-4">
              <div class="col-md-8">
                <p>Mensaje de Suscripción:</p>
                <p>Se envía cotización.</p>
              </div>
              <div class="col-md-4">
                <p>Fecha</p>
                <p>24/08/2022</p>
              </div>
              <div class="col-md-12 mt-3">
                <textarea class="form-control" v-model="comentario"></textarea>
              </div>
              <div class="col-md-12 mt-4">
                <label
                  >Adjunta tus archivos aquí (formato .pdf)
                  <input type="file" class="ml-2" id="file" />
                </label>
              </div>
              <div class="col-md-12 mt-4 d-flex justify-content-end">
                <button
                  class="btn btn-primary btn-rounded"
                  @click="enviarArchivo"
                >
                  Enviar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { convert } from "../../../../assets/helpers";

export default {
  props: {
    datosPoliza: Object,
    numeroSerie: String,
    altaFolioInnova: Function,
  },
  data() {
    return {
      numSerie: this.datosPoliza.INCISO[0].SERIE,
      comentario: "",
      archivos: [],
    };
  },
  methods: {
    guardarCambios() {
      this.$emit("update:numeroSerie", this.numSerie);
      this.altaFolioInnova({}, "B5", "B", "");
    },
    async enviarArchivo() {
      
      const file = document.getElementById("file").files[0];

      if (file) {

        const promise = convert.convertFileToBase64(file);

        promise.then((result) => {
          this.altaFolioInnova(
            {
              base64: result,
              nombre: file.name,
              contentType: file.type,
              extension: "pdf",
            },
            "B5",
            "B",
            this.comentario
          );
        });
      }
    },
  },
};
</script>